/**
 * 开普勒
 * @param {*} opts
 */
import { MPingClick, isJRAppKPL, getStaticConfig, isMiniProgram } from '@/util/common';

let lock = false;
let jrAppKeplerUrlEnable = false;
let from = 'yydw_baitiao';
try {
  jrAppKeplerUrlEnable = getStaticConfig('jrAppKeplerUrlEnable');
} catch (error) {
  console.log(error);
}

function openByKplUrl(url, delay, isForce) {
  const kepler = `https://click.k.jd.com/union?mtm_source=kepler-m&mtm_subsource=243531c251d64603809dbccf42b475f6&mopenbp5=${from}&mopenbp9=1&mopenbp10=OTHER_BAITIAO&returl=${encodeURIComponent(
    url
  )}`;

  const stt = setTimeout(() => {
    clearTimeout(stt);
    if (($.device && $.device.jdapp) || isForce) {
      window.location.href = url;
    } else {
      window.location.href = kepler;
    }
  }, delay || 200);
}

export function openByKpl(opts = { url: '', sku: '', eventId: '', eventParam: '', channel: 'default' }) {
  let channel = opts.channel;
  if ($.device.jdjr) {
    switch (channel) {
      case 'like':
        from = 'yydw_001';
        break;
      case 'recomend':
        from = 'yydw_003';
        break;
      case 'red_like':
        from = 'yydw_005';
        break;
      case 'pay_like':
        from = 'yydw_007';
        break;
      default:
        from = 'yydw_baitiao';
        break;
    }
  } else if ($.device.weixin) {
    switch (channel) {
      case 'like':
        from = 'yydw_002';
        break;
      case 'recomend':
        from = 'yydw_004';
        break;
      case 'red_like':
        from = 'yydw_006';
        break;
      case 'pay_like':
        from = 'yydw_008';
        break;
      default:
        from = 'yydw_baitiao_wx';
        break;
    }
  } else {
    from = 'yydw_baitiao';
  }

  if (opts && !lock) {
    try {
      MPingClick(opts);
    } catch (error) {
      console.log(error);
    }
    lock = true;
    const stt = setTimeout(() => {
      clearTimeout(stt);
      lock = false;
    }, 300);
    console.log(opts);
    const { sku, url } = opts;
    let jumpUrl = '';
    let productId = '';
    let _kplMap = {
      mopenbp5: from || 'yydw_baitiao',
      mopenbp9: '1',
      mopenbp10: 'OTHER_BAITIAO'
    };
    // 发日志
    try {
      if (typeof window.errorReport === 'function') {
        window.errorReport({
          logLevel: 'NORMAL',
          logData: '[优享免息]sku=' + sku + ',url=' + url,
          errorFileName: ('click start' || '') + window.location.search
        });
      }
    } catch (e) {
      console.log(e);
    }

    let _url = url;
    if (url && url.indexOf && url.indexOf('http') === 0) {
      _url = url;
    } else if (url && url.indexOf && url.indexOf('//') === 0) {
      _url = 'https:' + url;
    }

    if (sku) {
      jumpUrl = '64';
      productId = sku;
    } else if (url) {
      jumpUrl = '67';
      productId = _url;
    }
    if (typeof _url === 'string' && (_url.indexOf('btyingxiao/sfstore') > -1 || _url.indexOf('janb=yes') > -1) && $.device && $.device.jdjr) {
      const stt = setTimeout(() => {
        clearTimeout(stt);

        window.location.href = _url;
      }, 200);
    } else if (jumpUrl && $.device && $.device.jdjr && window.JrBridge) {
      if (isJRAppKPL()) {
        if (typeof _url === 'string' && _url.indexOf('http') > -1) {
          if (String(jrAppKeplerUrlEnable) === 'true') {
            openByKplUrl(_url);
          } else {
            openByKplUrl(_url, 200, true);
          }
        }
        return false;
      }

      // 发日志
      try {
        if (typeof window.errorReport === 'function') {
          window.errorReport({
            logLevel: 'NORMAL',
            logData: '[优享免息-defer.then]jumpUrl=' + jumpUrl + ',productId=' + productId + ',_kplMap=' + JSON.stringify(_kplMap),
            errorFileName: ('click start' || '') + window.location.search
          });
        }
      } catch (e) {
        console.log(e);
      }

      let lockBridge = false;
      const stt2 = setTimeout(() => {
        clearTimeout(stt2);
        if (opts.url && !lockBridge) {
          try {
            if (typeof window.errorReport === 'function') {
              window.errorReport({
                logLevel: 'NORMAL',
                logData: '[优享免息-开普勒降级]opts.url=' + opts.url,
                errorFileName: ('click start' || '') + window.location.search
              });
            }
          } catch (e) {
            console.log(e);
          }
        }
      }, 300);

      const stt = setTimeout(() => {
        clearTimeout(stt);
        // window.jsBridgeV3.onReady().then(api => {
        //   lockBridge = true;
        //   try {
        //     if (typeof window.errorReport === 'function') {
        //       window.errorReport({
        //         logLevel: 'NORMAL',
        //         logData: '[优享免息-onReady]jumpUrl=' + jumpUrl + ',productId=' + productId + ',_kplMap=' + JSON.stringify(_kplMap),
        //         errorFileName: ('click start' || '') + window.location.search
        //       });
        //     }
        //   } catch (e) {
        //     console.log(e);
        //   }

        //   api.jsOpenWeb({
        //     //跳转到金融APP原生模块
        //     jumpUrl: jumpUrl, //参考上边64-67的区别
        //     jumpType: 5, //登陆类型
        //     productId: productId, //参考上边64-67的区别
        //     isclose: false, //是否关闭m页，true关，false不关
        //     param: {
        //       //扩展参数
        //       type: 'yydw_baitiao', //默认为 ：jdjrApp
        //       kplMap: _kplMap
        //     }
        //   });
        // });

        lockBridge = true;
        try {
          if (typeof window.errorReport === 'function') {
            window.errorReport({
              logLevel: 'NORMAL',
              logData: '[优享免息-onReady]jumpUrl=' + jumpUrl + ',productId=' + productId + ',_kplMap=' + JSON.stringify(_kplMap),
              errorFileName: ('click start' || '') + window.location.search
            });
          }
        } catch (e) {
          console.log(e);
        }
        window.JrBridge.openView({
          target: jumpUrl,
          container: 'native',
          islogin: false,
          wallet: false,
          productId: productId,
          isclose: false,
          param: {
            type: 'yydw_baitiao', //默认为 ：jdjrApp
            kplMap: _kplMap
          }
        });
      }, 10);
    } else if (isMiniProgram()) {
      const stt = setTimeout(() => {
        clearTimeout(stt);
        window.wx && window.wx.miniProgram.navigateTo({ url: `/pages/product/product?wareId=${sku}` });
      }, 200);
    } else if (_url) {
      openByKplUrl(_url);
    }
  }
}
